<template>
  <div class="stake-amount-container">
    <h1 class="stake-amount-header">{{$HelperTools.toFinancialVal(amountstake)}}</h1>
    <p class="stake-amount-text">{{text1}}</p>
    <h1 class="stake-amount-header mgt24">{{percent}}</h1>
    <p class="stake-amount-text">{{text2}}</p>
  </div>
</template>

<script>
export default {
  name: "progresss",
  props: {
    amountstake: {
      type: Number
    },
    amountnostake: {
      type: Number
    },
    text1: {
      type: String
    },
    text2: {
      type: String
    },
  },
  mounted(){
    this.percent = (this.amountstake*100/(this.amountstake+this.amountnostake)).toFixed(3) + "%"
  },
  data() {
    return {
      percent: "",
    }
  },
};
</script>
<style lang="scss">
.stake-amount-text{
  line-height:20px;
  font-size:14px;
  font-weight: 400;
}
.lang_en .stake-amount-text{
    font-family: NunitoSans-Bold,'Avenir', Helvetica, Arial, sans-serif;
}
.stake-amount-header{
  line-height:32px;
  font-size:18px;
  font-weight:700;
}
.stake-amount-container{
  text-align:left;
  @include mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
}
.mgt24 {
  margin-top: 24px;
}
</style>

